import { request } from "../../config/API";
import authHeader from "./authHeader";
const endPoints = [
  // index 0
  {
    end: "qr/profile/", //for now adding subuser
    method: "get",
    description: "Get a Qr Profile",
  },
];

const getQrProfile = (qrId) =>
  request.get(endPoints[0].end + qrId, { headers: { ...authHeader() } });

const getQrPassbook = (qrId) =>
  request.get(endPoints[0].end + qrId + "/passbook", {
    headers: { ...authHeader() },
  });

const getGoogleWallet = (qrId) =>
  request.get(endPoints[0].end + qrId + "/google-wallet", {
    headers: { ...authHeader() },
  });

const vCardFunctions = {
  getQrProfile,
  getQrPassbook,
  getGoogleWallet,
};

export default vCardFunctions;
